module.exports = __webpack_public_path__ + "static/img/14.93f55bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/14.png
// module id = Z0gn
// module chunks = 0